<script lang="ts">
	import { createProgress, melt } from '@melt-ui/svelte';
	import { writable } from 'svelte/store';

	interface Props {
		currentProgress: number;
		max?: number;
	}

	let { currentProgress, max = 100 }: Props = $props();

	const {
		elements: { root },
		states: { value }
	} = createProgress({
		value: writable(currentProgress),
		max
	});

	$effect(() => {
		$value = currentProgress;
	});
</script>

<div use:melt={$root} class="bg-gray-faint relative h-2 w-full overflow-hidden rounded-full">
	<div
		class="h-full w-full bg-[#007dcb] transition-transform duration-[660ms]
          ease-[cubic-bezier(0.65,0,0.35,1)]"
		style={`transform: translateX(-${100 - (100 * ($value ?? 0)) / max}%)`}
	></div>
</div>
